import { api } from './api';

/**
 * Fetch reference data for EV Crisis Simulator (minerals with suppliers, segments, timelines, scenarios, OEMs).
 */
export const getEVCrisisReference = async () => {
  const response = await api.get('/api/ev-crisis-reference');
  if (!response.data?.success) throw new Error(response.data?.detail || 'Failed to load crisis reference');
  return response.data.data;
};

/**
 * Save an EV crisis simulation run. Payload uses keys: mineral_key, segment_key, timeline_key, oem_key, scenario_keys, etc.
 */
export const saveEVCrisisSimulation = async (payload) => {
  const response = await api.post('/api/ev-crisis-simulator/save', payload);
  if (!response.data?.success) throw new Error(response.data?.detail || 'Save failed');
  return response.data.simulation;
};

/**
 * List latest EV crisis simulation runs.
 */
export const listEVCrisisSimulations = async (limit = 100) => {
  const response = await api.get('/api/ev-crisis-simulator', { params: { limit } });
  if (!response.data?.success) throw new Error(response.data?.detail || 'List failed');
  return response.data.simulations;
};

/**
 * Get a single EV crisis simulation run by id.
 */
export const getEVCrisisSimulation = async (id) => {
  const response = await api.get(`/api/ev-crisis-simulator/${id}`);
  if (!response.data?.success) throw new Error(response.data?.detail || 'Not found');
  return response.data.simulation;
};

/**
 * Get Claude-powered crisis prediction. Backend analyzes EV stored data (minerals, suppliers,
 * segments, dashboard, recent runs) and returns supply_gap_pct, price_impact_pct,
 * time_to_crisis_days, economic_impact_cr, risk_index, summary, recommendations.
 * Payload: { mineral_key, segment_key, timeline_key, oem_key, scenario_keys, disruptions, policy_snapshot }
 */
export const getEVCrisisAIPrediction = async (payload) => {
  const response = await api.post('/api/ev-crisis-simulator/claude-predict', payload);
  if (!response.data?.success) throw new Error(response.data?.detail || 'Prediction failed');
  return response.data.prediction;
};

/**
 * Fetch recovery timeline points for one simulator context.
 */
export const getEVCrisisRecoveryTimeline = async (params) => {
  const response = await api.get('/api/ev-crisis-recovery-timeline', { params });
  if (!response.data?.success) throw new Error(response.data?.detail || 'Failed to load recovery timeline');
  return response.data.points || [];
};

/**
 * Upsert recovery timeline points for one simulator context.
 */
export const syncEVCrisisRecoveryTimeline = async (payload) => {
  const response = await api.post('/api/ev-crisis-recovery-timeline/sync', payload);
  if (!response.data?.success) throw new Error(response.data?.detail || 'Failed to sync recovery timeline');
  return response.data;
};
